<script>
import { merge, get } from 'lodash';
import { fandomTranslate } from "src/modules/common_module";

export default {
  props: {
    content: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: 'Evaluation Tool'
    },
    btnClass: {
      type: String,
      default: 'btn-primary'
    }
  },
  data() {
    return {
      loadingTime: false
    }
  },
  created() {
    const videoConfig = {
      autoplay: 0,
      interactive: true,
      preventInteractionTimeout: true,
      preventProgressBarEvents: true,
      interactionFeedbackTime: 1,
      prependEndVideo: true
    }

    if (Fandom.isTouchDevice()) {
      videoConfig.mute = 1; 
    }

    Vue.set(this.content, 'play',
      merge(this.content.play, {
        videoConfig: videoConfig
      })
    );
  },
  mounted() {
    Fandom.onEvent(`evaluation-end-${this.content.name}`, (data) => {
      console.log(data);
    });
    Vue.nextTick(() => {
      Fandom.executeOnce(`load-evaluation-tool-${this.content.id || this.content.$id}`, this.loadEvaluationTool);
    });
  },
  methods: {
    ft: fandomTranslate,
    loadEvaluationTool() {
      Vue.set(globalState, "videoPopupContent", {
        content: this.content,
        containerContent: this.content,
        endEvent: `evaluation-end-${this.content.name}`,
        portraitOnly: true,
        overvideoInteractionAudioUrl: get(this.content, ["overvideo_interaction_audio", "url"], null),
        clickAudioUrl: get(this.content, ["click_audio", "url"], null),
        evaluationTool: true,
        overvideoInteractionAudioVolume: parseFloat(get(this.content, ["overvideo_interaction_audio_volume"], '0.5')),
        playGAEventParams: {category: 'Interaction Test', action: 'Play Test', label: 'LP test play'},
        skipGAEventParams: {category: 'Interaction Test', action: 'Skip', label: 'Skip'},
        firstPlayCallback: () => {
          Fandom.post({
            url: '/api/v5/evaluation_tool/start',
            data: { content_name: this.content.name },
            success: (data) => {
              console.log(data);
            }
          });
        }
      });
    }
  },
  computed: { }
};
</script>

<template>
  <div>
    <button @click="loadEvaluationTool" :class="btnClass" class="btn" evaluation-tool-trigger>
      {{text}}
    </button>
  </div>
</template>